import { SB } from '@play-co/replicant';
import { maxEventEnergy } from '../inventory/inventory.ruleset';

export const competitiveEventSchema = SB.object({
  // Score in the event
  score: SB.int(),

  // For leaderboard sorting
  // In case of equal score, the earliest should be higher
  scoreUpdatedAt: SB.int(),

  // Claimed check
  claimed: SB.boolean(),

  // The gacha tickets exclusive to the event
  gachaTickets: SB.int(),

  // Current event energy
  // As per the spec it should be the same as regular energy
  energy: SB.int().min(0).default(maxEventEnergy),

  // For regeneration calculation
  energyRechargeStartTime: SB.int(),

  // Has the tutorial reward for the event been claimed
  tutorialComplete: SB.boolean(),
});

export const competitiveSchema = {
  competitiveEvent: SB.map(competitiveEventSchema).optional(),
};
